import { Toaster as SonnerToaster } from 'sonner';
import { useTheme } from '@/components/theme/theme-provider';

export function Toaster() {
  const { resolvedTheme } = useTheme();
  return (
    <SonnerToaster
      theme={resolvedTheme}
      position="bottom-right"
      richColors
      closeButton
    />
  );
}
